import axios from 'axios';
import { API_BASE_URL } from '@/config';

export async function getBusinessUnits(facilityId) {
  return (
    await axios.get(
      API_BASE_URL +
        '/business-units' +
        `${facilityId ? `?facilityId=${facilityId}` : ''}`,
    )
  ).data;
}

export async function getBusinessUnitsForForm(facilityId) {
  return (
    await axios.get(
      API_BASE_URL +
        '/business-units/for-forms' +
        `${facilityId ? `?facilityId=${facilityId}` : ''}`,
    )
  ).data;
}

export async function getBusinessUnit(id) {
  return (await axios.get(API_BASE_URL + '/business-units/' + id)).data;
}

export async function createBusinessUnit(formData) {
  return await axios.post(API_BASE_URL + '/business-units', formData);
}

export async function updateBusinessUnit(id, formData) {
  return await axios.put(API_BASE_URL + '/business-units/' + id, formData);
}

export async function deleteBusinessUnit(id) {
  return await axios.delete(API_BASE_URL + '/business-units/' + id);
}
